import { call } from '@masar/api-client';
import { roots, useApi } from '@masar/api-client/query';
import { useQuery } from '@tanstack/react-query';
import { useCan } from '../app/session';

/** Counts shown next to navigation items (prototype wsSide badges). */
export function useNavBadges(): Record<string, number> {
  const api = useApi();
  const can = useCan();
  const today = useQuery({
    queryKey: [roots.ops, 'today'],
    queryFn: ({ signal }) => call(api.GET('/v1/ops/today', { signal })),
    enabled: can('p.today'),
    staleTime: 30_000,
  });
  const wallet = useQuery({
    queryKey: [roots.credits, 'summary'],
    queryFn: ({ signal }) => call(api.GET('/v1/wallet/summary', { signal })),
    enabled: can('p.vouchers'),
    staleTime: 30_000,
  });
  const out: Record<string, number> = {};
  if (today.data) {
    out.checkin = today.data.pickups.filter((b) => b.status === 'confirmed').length;
    out.checkout = today.data.returns.filter((b) => b.status === 'active').length;
  }
  if (wallet.data) out.vouchers = wallet.data.pending_count;
  return out;
}
